import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login } from '../services/auth';
import { FiMail, FiLock } from 'react-icons/fi';
import { toast } from 'react-hot-toast';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login: authLogin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      authLogin(result.user);
      toast.success('ចូលប្រព័ន្ធដោយជោគជ័យ!');
      navigate('/');
    } else {
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            សូមស្វាគមន៍មកកាន់ NAa Collection
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            មិនទាន់មានគណនី?{' '}
            <Link to="/register" className="font-medium text-black hover:text-gray-700">
              ចុះឈ្មោះ
            </Link>
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm space-y-4">
            <div className="relative">
              <FiMail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                placeholder="អ៊ីមែល"
              />
            </div>
            
            <div className="relative">
              <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                placeholder="ពាក្យសម្ងាត់"
              />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="text-sm">
              <Link to="/forgot-password" className="font-medium text-black hover:text-gray-700">
                ភ្លេចពាក្យសម្ងាត់?
              </Link>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'កំពុងចូល...' : 'ចូលប្រព័ន្ធ'}
          </button>
        </form>

        {/* Contact Info */}
        <div className="text-center pt-4">
          <p className="text-xs text-gray-500">
            ទំនាក់ទំនងតាម Telegram:{' '}
            <a 
              href="https://t.me/nnick321" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-black hover:underline font-medium"
            >
              @nnick321
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;